import ActionHandler, {ActionPlaceholder} from "@/utils/moreMenu/ActionHandler.ts";
import MetaData from "@/utils/common/MetaData.ts";
import PreferencesRequest from "@/utils/constants/PreferencesRequest.ts";
import DomainBaseEntities from "@/utils/constants/DomainBaseEntities.ts";
import OwnerType from "@/utils/constants/OwnerType.ts";
import ActionPerformer from "@/utils/moreMenu/ActionPerformer.ts";
import ActionPerformerUtil from "@/utils/moreMenu/ActionPerformerUtil.ts";
import LoginUtils from "@/utils/login/LoginUtils.ts";
import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";
import GenericValues from "@/utils/common/GenericValues.ts";
import FieldType from "@/utils/constants/FieldType.ts";
import BaseDispatcher from "@/utils/presenters/BaseDispatcher.ts";
import {Callback} from "@quasar/app-vite";
import FlatObjectAccessor from "@/utils/moreMenu/FlatObjectAccessor.ts";
import UIPreferences = namaTypes.UIPreferences;
import FetchPreferencesRequest = namaTypes.FetchPreferencesRequest;
import DTOFilledQuestionField = namaTypes.DTOFilledQuestionField;
import GenericValue = namaTypes.GenericValue;
import ListOfGenericValues = namaTypes.ListOfGenericValues;
import NaMaMetaData = namaTypes.NaMaMetaData;
import ActionPerformerHelper from "@/utils/moreMenu/ActionPerfomerHelper.ts";
import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import IdsAndConstants from "@/utils/UIConstants/IdsAndConstants.ts";

export default class DialogUtils {
  static async showPasswordMustBeChangedDialog() {
    const req: FetchPreferencesRequest = {};

    req.owner = {ownerType: OwnerType.Entity, ownerId: DomainBaseEntities.User};
    req.properties = [PreferencesRequest.META_DATA];

    await MetaData.fetchPreferences(req, async (preferences: UIPreferences) => {
      const metadata: NaMaMetaData = preferences.metaData ?? {};

      const actionPerformer: ActionPerformer = {
        editDashboardElements(): void {
        }, fetchLastTerminalPayTrnx(): Promise<void> {
          return Promise.resolve(undefined);
        }, payInvoice(): Promise<void> {
          return Promise.resolve(undefined);
        }, readFirstWeight(): Promise<void> {
          return Promise.resolve(undefined);
        }, readSecondWeight(): Promise<void> {
          return Promise.resolve(undefined);
        }, runCustomAction(action: ActionPlaceholder): Promise<void> {
          return Promise.resolve(undefined);
        }, async showCurrentApprovalCase(): Promise<void> {
          return Promise.resolve(undefined);
        }, signDocuments(onlySelected: boolean): Promise<void> {
          return Promise.resolve(undefined);
        },
        async bulkEdit(action: ActionPlaceholder): Promise<void> {
        },
        async performAction(action: ActionPlaceholder, questionFields: DTOFilledQuestionField[]) {
          let helper:ActionPerformerHelper = {
            beforeGoToPlace(): void {
            }, fetchPresenter(): WidgetsPresenter {
              return {} as WidgetsPresenter;
            }, onGuiActionUpdateList(updateList: namaTypes.ListOfGenericValues | undefined, contextRow?: number): void {
            },
            updateRelatedFields(result: ListOfGenericValues, row: number): boolean {
              return false;
            },
            listViewName(): string | undefined {
              return undefined;
            },
            editViewName(): string | undefined {
              return undefined;
            },
            async refresh(doNotHideErrors: boolean, doNotHideWarnings: boolean) {
              await LoginUtils.logout();
            },
            getEntityType(): string {
              return DomainBaseEntities.User;
            },
            entityMetadata(): namaTypes.NaMaMetaData {
              return metadata;
            },
            addContextFieldsToAction(
              contextFieldIds: string[],
              contextRow: number,
              contextFields: Record<string, GenericValue>
            ): void {
              contextFields[CommonFieldIds.ID] = GenericValues.createGenericValueForType(CommonFieldIds.ID, LoginUtils.currentUserId(), FieldType.Text)
            },
            getAccessor(): FlatObjectAccessor | null {
              return null;
            },

            getSearchAndSuggestionsProvider(): BaseDispatcher | null {
              return null;
            }

          };
          await ActionPerformerUtil.performAction(action, questionFields, metadata, helper);
        },
        isRecordNotSaved(): boolean {
          return false;
        },
        getSearchContextProvider(): BaseDispatcher | undefined {
          return undefined;
        },
        calcDefaultsOf(
          action: ActionPlaceholder,
          callback: Callback<DTOFilledQuestionField[]>
        ): void {
          callback([]);
        }
      }

      const actionHandler = new ActionHandler({id: IdsAndConstants.SET_NEW_PASSWORD_ACTION}, preferences.metaData!, DomainBaseEntities.User, actionPerformer).performAction();
    })
  }
}
